import { createContext, useContext } from "react";

import { FarmTo } from "../../../generated/api/agroevidence";

const farmContext = createContext<FarmTo | undefined>(undefined);

const CfFarmProvider = ({
  children,
  farm,
}: React.PropsWithChildren<{ farm: FarmTo }>) => (
  <farmContext.Provider value={farm}>{children}</farmContext.Provider>
);

const withFarm = <T,>(WrappedComponent: React.ComponentType<T>) => {
  const EnhancedComponent = (props: Omit<T, keyof FarmTo | "farm">) => (
    <farmContext.Consumer>
      {(context) => <WrappedComponent farm={context} {...(props as T)} />}
    </farmContext.Consumer>
  );

  return EnhancedComponent;
};

const useFarm = (): FarmTo | undefined => useContext(farmContext);

export { CfFarmProvider, withFarm, useFarm };
